import React from 'react'
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Check, Close } from '@mui/icons-material'
import { InfoTable as InfoTableType } from '../../types/table'

interface Props {
  table: InfoTableType
}

const InfoTable: React.FC<Props> = ({ table }) => {
  const { classes, cx } = useStyles()
  const cellEntry = (cell: string) => {
    switch (cell) {
      case '#icon:checkmark':
        return <Check className={classes.check} />
      case '#icon:x':
        return <Close color="secondary" />
      default:
        return cell
    }
  }

  return (
    <Box className={classes.box}>
      <Box className={classes.boxInner}>
        <Paper className={classes.paper} elevation={4}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {table.data.rowTitles.map((cell, index) => (
                  <TableCell
                    className={cx({
                      [classes.cell]: true,
                      [classes.cellRowTitle]: true,
                      [classes.cellHead]: true,
                    })}
                    key={`table-head-cell-${index}`}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {table.data.rows.map((row, index) => (
                <TableRow className={classes.row} key={`table-row-${index}`}>
                  {row.map((cell, cellIndex) => (
                    <TableCell
                      className={cx({
                        [classes.cell]: true,
                        [classes.cellTitle]: cell.title,
                      })}
                      component={cell.title ? 'th' : 'td'}
                      key={`row-${index}-cell-${cellIndex}`}
                    >
                      {cellEntry(cell.entry)}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  box: {
    [theme.breakpoints.down('md')]: {
      overflow: 'scroll',
      width: '114%',
    },
  },
  boxInner: {
    [theme.breakpoints.down('md')]: {
      padding: '.5em 6% .5em 6%',
      width: 'calc(53.13em + 12.31%)',
    },
  },
  cell: {
    border: 'none',
    fontSize: '1.13em',
    padding: '.94em 2.78em',
    textAlign: 'center',

    '&:nth-child(even)': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.action.selected,
    },
    '&:nth-child(1)': {
      paddingLeft: '1.78rem',
    },

    [theme.breakpoints.down('md')]: {
      fontSize: '1em',
    },
  },
  cellHead: {
    paddingTop: '1.83em',
  },
  cellRowTitle: {
    '&:nth-child(1)': {
      textAlign: 'left',
    },
    '&:nth-child(even)': {
      fontWeight: 700,
    },
  },
  cellTitle: {
    fontWeight: 700,
    textAlign: 'left',
  },
  check: {
    color: theme.palette.action.selected,
  },
  paper: {
    backgroundColor: theme.palette.background.default,
    boxShadow: '0 .25em .94em 0 rgba(34, 34, 34, 0.1)',

    [theme.breakpoints.down('md')]: {
      width: '53.13em',
    },
  },
  row: {
    '&:last-child': {
      '& td': {
        paddingBottom: '2.56rem',
      },
      '& th': {
        paddingBottom: '2.56rem',
      },
    },
  },
}))

export default InfoTable
